import { useParams } from 'react-router-dom';

import { AindaNaoConstruido } from '../../shared/ui/AindaNaoConstruido';
import { mapaDeNavegacao } from '../../shared/navegacao/mapaDeNavegacao';

/**
 * Uma só implementação para as doze telas que ainda não existem — o texto
 * vem do mapa de navegação, que é a única fonte. Doze componentes iguais
 * seriam doze lugares para a promessa divergir do menu.
 */
export function PaginaEmConstrucao({ chave }: { chave?: string }): React.JSX.Element {
  const parametros = useParams<{ chave: string }>();
  const alvo = chave ?? parametros.chave ?? '';
  const entrada = mapaDeNavegacao.find((item) => item.chave === alvo);

  if (entrada === undefined) {
    return (
      <AindaNaoConstruido
        titulo="Tela desconhecida"
        promessa="Esta rota não corresponde a nenhuma tela do produto. Use o menu à esquerda."
      />
    );
  }

  return <AindaNaoConstruido titulo={entrada.rotulo} promessa={entrada.promessa} />;
}
